<div [formGroup]="addressForm" class="flex flex-column lg:flex-row w-full h-full mb-2 flex-wrap">
  <!-- Zip and City -->
  <div class="zip-city w-full lg:w-auto lg:mr-3">
    <bi-zip-code-input #zipInput formControlName="zipcode" class="block w-full" [label]="'shared.ZipcodeShort' | translate" [countryId]="countryId()" [inputGroupLabel]="cityForZip()" />

    @if (showCityNotFoundError()) {
      <div role="alert">
        <p class="field-error" translate>errorMessages.ZipcodeNotFound</p>
      </div>
    }
  </div>

  <!-- Street -->
  <div class="flex-grow-1 mt-3 lg:mt-0">
    <label class="FieldLabel" for="street" translate>shared.Street</label>
    <p-autoComplete
      #autoComplete
      data-uitest="test-street-auto-complete"
      inputId="street"
      dataKey="streetName"
      formControlName="street"
      field="streetName"
      styleClass="w-full"
      inputStyleClass="w-full"
      [maxlength]="maxLengthStreet"
      [forceSelection]="false"
      [showEmptyMessage]="true"
      [emptyMessage]="'errorMessages.StreetNotFound' | translate"
      [suggestions]="filteredStreets$ | async"
      [placeholder]="'shared.EnterOrSearchStreetName' | translate"
      [autoOptionFocus]="true"
      (completeMethod)="searchStreets($event.query)"
      (onSelect)="onStreetSelected($event.value)"
      (onBlur)="onStreetBlur()"
      (onKeyUp)="onStreetKeyUp($event)"
      (onShow)="setStreetListAriaLabel()"
    />

    @if (streetCtrl.errors?.notFound) {
      <div role="alert">
        <p class="field-error" translate>errorMessages.StreetInvalidOrNotAvailable</p>
      </div>
    }
  </div>

  <!-- House Number -->
  <div class="house-number lg:ml-3 lg:mr-1 mt-3 lg:mt-0">
    <label class="FieldLabel" for="house-number-input" translate>shared.HouseNumber</label>

    <input
      type="number"
      autocomplete="on"
      pInputText
      [attr.aria-invalid]="showNoAddressesFound()"
      id="house-number-input"
      [placeholder]="'shared.EnterHouseNumber' | translate"
      formControlName="houseNumber"
      class="w-full test-address-house-number"
    />

    @if (showNoAddressesFound()) {
      <div role="alert">
        <p class="field-error" translate>errorMessages.HousenumberNotFound</p>
      </div>
    }
  </div>

  <div class="w-full"></div>

  <div class="w-full relative" aria-live="assertive">
    @if (loadingAddresses()) {
      <bi-spinner [centerInParent]="true" [ariaLabel]="'shared.LoadingAddresses' | translate" />
    } @else if (showResultList() && foundAddresses().length > 0) {
      <div class="w-12 mb-4 mt-3 pl-0" [class.overflow-y-auto]="foundAddresses().length > 1" style="max-height: 300px">
        <div role="list" biAutofocus [attr.aria-label]="'messages.FoundAddresses' | translate" class="flex flex-column gap-3 w-12 address-selection-list" @fadeInDown>
          @for (addrezz of foundAddresses(); track addrezz.kvhx) {
            <div role="listitem" aria-live="off" class="w-12 flex align-items-center justify-content-between row-hover border-round">
              <span tabIndex="0" class="focus-highlight test-display-address">{{ addrezz.displayValue }}</span>
              <p-button
                type="submit"
                class="ml-auto"
                styleClass="test-subscribe-to-address"
                [label]="buttonLabelTranslationKey() | translate"
                [ariaLabel]="(buttonLabelTranslationKey() | translate) + ' ' + addrezz.displayValue"
                (click)="$event.preventDefault(); addressSelected(addrezz, $event.target)"
              />
            </div>
          }
        </div>
      </div>
    }
  </div>

  @if (showResultList() && foundAddresses().length > 0) {
    <button class="hidden-accessible" (click)="reset()" (key.enter)="reset()" translate>accessibility.SearchNewAddress</button>
  }
</div>
